import authenticatedRequest from '../authenticatedRequest';
import labelRequest from '../labelRequest';
import invariant from 'invariant';

export default function updateAddress(params) {
    const { baseUrl, brandId, country, address, uberToken, clientId, clientSecret } = params;
    invariant(baseUrl, 'baseUrl is a required param of updateAddress()');
    invariant(brandId, 'brandId is a required param of updateAddress()');
    invariant(country, 'country is a required param of updateAddress()');
    invariant(address, 'address is a required param of updateAddress()');
    const { addressId = address.addressId } = params;
    invariant(addressId, 'addressId is a required param of updateAddress()');
    invariant(uberToken, 'uberToken is a required param of updateAddress()');
    invariant(clientId, 'clientId is a required param of updateAddress()');

    const headers = new Headers({ 'Content-Type': 'application/json' });
    const url = `${baseUrl}wcs/resources/store/${brandId}_${country.toLowerCase()}/person/@self/contact/byAddressId/${addressId}`;

    return labelRequest(
        authenticatedRequest(new Request(url, { headers, method: 'PUT', body: JSON.stringify(address) }), uberToken, clientId, clientSecret),
        'updateAddress',
    );
}
